import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { useMainContainerMinMargins } from '@v4/components/common/SectionItem'
import { TEXT_POSITION } from '../../CallToAction.const'
import useStyles from './Cta5.styled'

export const useCta5 = props => {
	const { metaData } = props
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
	const minMargins = useMainContainerMinMargins()
	const classes = useStyles({ ...props, minMargins })

	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.image })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { handleFocus: handleAdditionalClick } = useFieldFocus({ metaData: metaData.additionalText })
	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: additionalTextEditable, handleChange: handleAdditionalTextChange } = useEditorMeta({
		metaData: metaData.additionalText,
		key: 'additionalText',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const image = isMobile && metaData.mobileImage?.image ? metaData.mobileImage : metaData.image

	const isBackground = metaData.mobileImagePosition?.isBackgroundImage

	const isImageExist = !!image?.image

	return [
		{
			classes,
			isMobile,
			withImage: isImageExist && (!isMobile || !isBackground),
			image,
			withBgImage: isImageExist && isMobile && isBackground,
			mobileAlignment: metaData.mobileAlignment?.metaValue,
			mobileButtonWidth: metaData.mobileButtonWidth?.isWide ? '100%' : 'auto',
			direction: isMobile ? metaData.mobileImagePosition?.contentReverseDirection() : null,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			additionalPosition: TEXT_POSITION.BOTTOM,
			additionalTextKey: metaData.additionalText?.tierKey,
			additionalText: metaData.additionalText?.metaValue,
			additionalTextConfig: metaData.additionalText?.config,
			additionalTextEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextConfig: metaData.buttonText?.config,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonTextEditable,
		},
		{
			handleImageClick,
			handleTextClick,
			handleButtonClick,
			handleAdditionalClick,
			handleTextChange,
			handleAdditionalTextChange,
			handleButtonTextChange,
		},
	]
}
